module.exports = __webpack_public_path__ + "assets/img/show-c.0f489a7c.png";